// Shared inline-style tokens extracted from app.jsx (decomposition). Plain
// style objects reused across many form/input surfaces — imported by app.jsx
// and by extracted components so both resolve the same source.

// Standard text-input style: compact padding, hairline border, full width.
export const inputStyle = {
  padding: '6px 8px', fontSize: 13, border: '1px solid #d0d4d9', borderRadius: 6,
  fontFamily: 'inherit', width: '100%',
};

// Time-period badge colors: named periods get a fixed hue; anything else
// cycles through a palette by index. Used by the task board, time-period
// manager, and payroll period breakdown.
const PERIOD_COLORS = {
  Opening: 'bg-purple-100 text-purple-800',
  Morning: 'bg-amber-100 text-amber-800',
  Midday: 'bg-sky-100 text-sky-800',
  Afternoon: 'bg-orange-100 text-orange-800',
  Closing: 'bg-slate-200 text-slate-700',
};
const PERIOD_COLOR_CYCLE = [
  'bg-teal-100 text-teal-800','bg-rose-100 text-rose-800','bg-indigo-100 text-indigo-800',
  'bg-lime-100 text-lime-800','bg-cyan-100 text-cyan-800','bg-fuchsia-100 text-fuchsia-800',
];
export function periodColor(name, index) {
  return PERIOD_COLORS[name] || PERIOD_COLOR_CYCLE[index % PERIOD_COLOR_CYCLE.length] || 'bg-gray-100 text-gray-700';
}

// Document mime-type → emoji. Used by the compliance document lists.
export const DOC_ICON = { 'application/pdf':'📄', 'image/jpeg':'🖼️', 'image/png':'🖼️',
  'application/msword':'📝', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':'📝' };
export function docIcon(fileType) { return DOC_ICON[fileType] || '📎'; }
